<script setup lang="ts">
import { User } from 'lucide-vue-next'

const { formatPhoneNumber } = useNumber()

export interface PropsRowCustomer {
  countryFlag?: string | null
  email?: string | null
  hasOptin?: boolean | null
  id: string | number
  loyaltyCardNumber?: string | null
  name?: string | null
  phone?: string | null
}

const props = withDefaults(defineProps<PropsRowCustomer>(), {
  countryFlag: null,
  email: null,
  hasOptin: false,
  hasOptinEmail: false,
  loyaltyCardNumber: null,
  name: null,
  phone: null
})

const fallbackInitial = computed(() => {
  const source = (props.name ?? props.email ?? '').trim()
  const firstChar = source.charAt(0)
  return /[a-zA-Z]/.test(firstChar) ? firstChar.toUpperCase() : null
})

const formattedPhone = computed(() => formatPhoneNumber(props.phone))
</script>

<template>
  <div class="flex items-center">
    <div class="hidden shrink-0 sm:block">
      <span class="relative inline-block">
        <Avatar class="size-9">
          <AvatarFallback>
            <span v-if="fallbackInitial">{{ fallbackInitial }}</span>
            <User v-else class="h-4 w-4 text-muted-foreground" />
          </AvatarFallback>
        </Avatar>
        <span
          class="absolute right-0 top-0 block h-2 w-2 rounded-full ring-2 ring-white"
          :class="hasOptin ? 'bg-green-400' : 'bg-foreground-disabled'"
        />
        <span
          v-if="countryFlag"
          class="absolute bottom-0 right-0 hidden h-2.5 w-2.5 rounded-full bg-cover bg-center ring-2 ring-white sm:block"
          :style="{ backgroundImage: `url('${countryFlag}')` }"
        >
        </span>
      </span>
    </div>
    <div class="ml-2 text-left sm:ml-3 align-top">
      <div class="text-sm font-medium text-primary hover:text-primary/80">
        {{ formattedPhone ?? loyaltyCardNumber ?? email ?? name }}
      </div>
      <div v-if="phone || loyaltyCardNumber || email" class="hidden text-sm capitalize text-muted-foreground sm:block">
        {{ name }}
      </div>
      <div
        v-if="email && (phone || loyaltyCardNumber)"
        class="block w-44 truncate text-sm lowercase text-muted-foreground sm:hidden"
      >
        {{ email }}
      </div>
    </div>
  </div>
</template>
